<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <router-link :to="{ path:`${roterPre}` + '/product/outreach/addOutreach' }">
          <el-button size="small" type="primary">添加商品</el-button>
        </router-link>
      </div>
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form inline size="small" label-width="110px">
            <el-form-item label="商品分类：">
              <el-cascader v-model="tableFrom.pid" class="selWidth" :options="merCateList" :props="{ checkStrictly: true, emitPath:false }" clearable @change="getList(1)" />
            </el-form-item>
            <el-form-item label="品牌：">
              <el-select
                v-model="tableFrom.brand_id"
                clearable
                filterable
                placeholder="请选择"
                class="selWidth"
                @change="getList(1)"
              >
                <el-option
                  v-for="item in brandSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="类型：">
              <el-select
                v-model="tableFrom.platType"
                clearable
                filterable
                placeholder="请选择"
                class="selWidth"
                @change="getList(1)"
              >
                <el-option
                  v-for="(key,item) in platTypeSelect"
                  :key="item"
                  :label="key"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="是否上架">
              <el-select
                v-model="tableFrom.is_show"
                placeholder="请选择"
                class="filter-item selWidth"
                clearable
                @change="getList(1)"
              >
                <el-option label="上架" value="1"/>
                <el-option label="下架" value="0"/>
              </el-select>
            </el-form-item>
            <el-form-item label="商品搜索：">
              <el-input v-model="tableFrom.keyword" @keyup.enter.native="getList(1)" placeholder="请输入商品名称，关键字，产品编号" class="selWidth">
                <el-button slot="append" icon="el-icon-search" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>

          </el-form>
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          label="ID"
          prop="outreach_store_id"
          min-width="100" />
        <el-table-column label="商品图" min-width="80">
          <template slot-scope="scope">
            <div class="demo-image__preview">
              <el-image style="width: 36px; height: 36px" :src="scope.row.mainPic" :preview-src-list="[scope.row.mainPic]" />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="商品标题"
          prop="title"
          min-width="100" />
        <el-table-column
          label="商户类型"
          prop="platType"
          min-width="100" />
        <el-table-column
          label="店铺名称"
          prop="shopName"
          min-width="100" />
        <el-table-column
          label="商品售价"
          prop="actualPrice"
          min-width="100" />
        <el-table-column
          label="销量"
          prop="monthSales"
          min-width="100" />

        <el-table-column
          prop="sort"
          label="排序"
          min-width="100"
        />
        <el-table-column
          prop="storeCategory.cate_name"
          label="分类"
          min-width="100"
        />
        <el-table-column
          prop="brand.brand_name"
          label="品牌"
          min-width="100"
        />
        <el-table-column
          prop="create_time"
          label="时间"
          min-width="150"
        />
        <el-table-column prop="status" label="是否上架" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.is_show" :active-value="1" :inactive-value="0" active-text="下架" inactive-text="上架" @change="onchangeIsShow(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100" fixed="right">
          <template slot-scope="scope">
            <router-link  :to="{path: roterPre + '/product/outreach/editOutreach/' + scope.row.outreach_store_id}">
              <el-button type="text" size="small" class="mr10">编辑</el-button>
            </router-link>
            <el-button type="text" size="small" @click="handleDelete(scope.row.outreach_store_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
    <!--审核-->
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {
  communityListApi, communityStatusApi, communityUpdateApi, communityAuditApi, communityDetailApi, communityDeleteApi, communityOffApi,
  communityCateOptionApi, communityTopicOptionApi, communityTitleApi
} from '@/api/community'
import { roterPre } from '@/settings'
import {
  brandSearchListApi,
  categoryListApi,
  outreachChangeApi,
  outreachListApi, outreachProductDeleteApi, platTypeSelectListApi
} from "@/api/product";
export default {
  name: 'communityTopic',
  data() {
    return {
      moren: require("@/assets/images/f.png"),
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      isChecked: false,
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      roterPre: roterPre,
      tableFrom: {
        page: 1,
        limit: 20,
        is_type: '1',
        status: "",
        keyword: "",
        username: "",
        category_id: "",
        topic_id: ""
      },

      cateSelect: [],
      topicSelect: [],
      dialogVisible: false,
      loading: false,
      isExamine: false,
      community_id: "",
      formData: {},
      merCateList: [],
      brandSelect: [],
      platTypeSelect: [],
    }
  },
  mounted() {
    this.getList(1)
    this.getCategorySelect()
    this.getBrandSelect()
    this.getPlatTypeSelect()

  },
  methods: {
    // 商户分类；
    getCategorySelect() {
      categoryListApi({'min_level': 1}).then(res => {
        this.merCateList = res.data
      }).catch(res => {
        this.$message.error(res.message)
      })
    },
    getBrandSelect() {
      brandSearchListApi().then(res => {
        this.brandSelect = res.data
      }).catch(res => {
        this.$message.error(res.message)
      })
    },
    getPlatTypeSelect() {
      platTypeSelectListApi().then(res => {
        this.platTypeSelect = res.data
      }).catch(res => {
        this.$message.error(res.message)
      })
    },
    onchangeIsShow(row) {
      outreachChangeApi(row.outreach_store_id, row.is_show).then(({message}) => {
        this.$message.success(message)
        this.getList('')
      }).catch(({message}) => {
        this.$message.error(message)
        this.getList('')
      })
    },
    // 列表
    getList(num) {
      this.listLoading = true
      this.tableFrom.page = num ? num : this.tableFrom.page
      outreachListApi(this.tableFrom).then(res => {
        this.tableData.data = res.data.list
        this.tableData.total = res.data.count
        this.listLoading = false
      }).catch(res => {
        this.listLoading = false
        this.$message.error(res.message)
      })
    },
    pageChange(page) {
      this.tableFrom.page = page
      this.getList('')
    },
    handleSizeChange(val) {
      this.tableFrom.limit = val
      this.getList('')
    },



    // 详情
    onDetail(id) {
      this.community_id = id;
      this.dialogVisible = true;
      this.isExamine = false;
      communityDetailApi(id).then((res) => {
        this.formData = res.data
      }).catch(({ message }) => {
        this.$message.error(message)
      })
    },
    // 删除
    handleDelete(id, idx) {
      this.$modalSure('确定删除该商品').then(() => {
        outreachProductDeleteApi(id).then(({ message }) => {
          this.$message.success(message)
          this.getList('')
        }).catch(({ message }) => {
          this.$message.error(message)
        })
      })
    },
  }
}
</script>

<style scoped lang="scss">
.box-container {
  overflow: hidden;
}
.box-container .list {
  float: left;
  line-height: 40px;
}
.box-container .sp {
  width: 50%;
}
.box-container .sp3 {
  width: 33.3333%;
}
.box-container .sp100 {
  width: 100%;
}
.box-container .list .name {
  display: inline-block;
  width: 150px;
  text-align: right;
  color: #606266;
}
.box-container .list.image {
  margin-bottom: 40px;
}
.box-container .list.image img {
  position: relative;
  top: 40px;
}
/deep/.el-form-item__content .el-rate{
  position: relative;
  top: 8px;
}
</style>
